import React from 'react'
import { injectIntl } from 'react-intl'

import Icon from '../../components/common/icon/Icon'
import DataTable from '../../components/common/dataTable/DataTable'
import DataTableHeader from '../../components/common/dataTable/DataTableHeader'
import DataTableHeaderCol from '../../components/common/dataTable/DataTableHeaderCol'
import DataTableRow from '../../components/common/dataTable/DataTableRow'
import DataTableCol from '../../components/common/dataTable/DataTableCol'

import Pager from '../../components/common/pager/Pager'

import TruncateAndTooltip from '../../components/common/truncateAndTooltip/TruncateAndTooltip'
import SingleLoader from '../../components/common/singleLoader/SingleLoader'
import MessageFeedback from '../../components/common/messageFeedback/MessageFeedback'

import { translateSpecialLink, isSpecialLink } from '../../services/SpecialLinks'

const AggregateReportLinks = ({
  intl, error, loading, items, pageNumber, pageSize, totalItems, onChangePager, onReload,
  loadingNext,
  loadingPrev,
  pagerDisabled
}) => {
  const pagerProps = {
    currentPage: pageNumber,
    itemsPerPage: pageSize,
    totalItems: totalItems,
    onChange: onChangePager,
    ofLabel: intl.formatMessage({ id: 'Load.Pager.Of' }),
    itemsLabel: intl.formatMessage({ id: 'Load.Pager.Items' }),
    loadingNext,
    loadingPrev,
    disabled: pagerDisabled,
    className: 'test-AggregateReportPubb-linkPager'
  }
  const loaderProps = {
    height: '300px'
  }

  function renderItem (item, index) {
    const subject = (item.Subject) ? `ID ${item.IdMessage} - ${item.Subject}` : ''

    return (
      <DataTableRow key={index}>
        <DataTableCol width='1'>{item.IdList}</DataTableCol>
        <DataTableCol width='10' wrapperEl='div'>
          <p className='container_word-to-break frontend-m-bottom-xx-sm'><strong>{renderUrl(item)}</strong></p>
          {item.error && <Icon family='fa' icon='exclamation-triangle' className='text-light' tooltipText={intl.formatMessage({ id: 'Load.Common.LoadDataError' })} />}
          {!item.error && !subject && <p className='is-loading' />}
          {!item.error && subject && <TruncateAndTooltip text={subject} />}
        </DataTableCol>
        <DataTableCol width='1' wrapperEl=''>
          <p className='frontend-text-right'><strong>{intl.formatNumber(item.TotalClicks)}</strong></p>
        </DataTableCol>

      </DataTableRow>
    )
  }

  function renderUrl (item) {
    return isSpecialLink(item.SpecialLinkType)
      ? (<span>{translateSpecialLink(intl, item.SpecialLinkType)}{' '}<em>({intl.formatMessage({ id: 'Load.Statistics.SpecialLink' })})</em></span>)
      : item.Url
  }

  return (
    <div className='frontend-row frontend-box'>
      <h2 className='frontend-m-bottom-x-sm'>{intl.formatMessage({ id: 'Load.Statistics.LinksList' })}</h2>

      <section>
        <DataTable>
          <DataTableHeader>
            <DataTableHeaderCol width='1'>{intl.formatMessage({ id: 'Load.MailupCommon.List' })}</DataTableHeaderCol>
            <DataTableHeaderCol width='10'>{intl.formatMessage({ id: 'Load.Statistics.URL' })}</DataTableHeaderCol>
            <DataTableHeaderCol width='1'>{intl.formatMessage({ id: 'Load.Common.TotalClicks' })}</DataTableHeaderCol>

          </DataTableHeader>
          {error &&
            <DataTableRow className='no-border frontend-m-bottom-sm'>
              <div className='frontend-box frontend-p-bottom'>
                <Icon family='fa' icon='exclamation-triangle' className='text-light' />&nbsp;
                <span>{intl.formatMessage({ id: 'Load.Common.LoadDataError' })}</span>
              </div>
            </DataTableRow>}

          {!error && loading && <SingleLoader {...loaderProps} />}

          {!error && !loading && items.map((item, index) => renderItem(item, index))}
        </DataTable>
        {!error && <Pager {...pagerProps} />}

      </section>

    </div>

  )
}

export default injectIntl(AggregateReportLinks)
